import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { FormField } from '../../FormField/FormField.js';
import { useFormContext } from '../FormContext/FormContext.js';
import { useFormControlValidation } from './use_form_control_validation.js';
import { jsx } from 'react/jsx-runtime';

var FormControlV2 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$value, _error$message, _formContext$inlineAl;
  var formContext = useFormContext();
  var _React$useState = React.useState((_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : formContext.defaultValuesRef.current[props.name]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var _useFormControlValida = useFormControlValidation({
      ref: ref,
      validation: props.validation,
      value: props.value
    }),
    error = _useFormControlValida.error,
    onValidate = _useFormControlValida.onValidate;
  var onUpdateValue = React.useCallback(function (val) {
    setValue(val);
  }, []);
  var _onChange = React.useCallback(function (newValue) {
    setValue(newValue);
    formContext.setFormControlRef(props.name, onUpdateValue, onValidate, newValue);
    if (props.onChange) {
      props.onChange(newValue);
    }
    formContext.onChange(props.name, newValue);
  }, [formContext, onUpdateValue, onValidate, props.name, props.onChange]);
  var onBlur = function onBlur() {};
  React.useEffect(function () {
    return function () {
      formContext.clearFormControlRef(props.name);
    };
  }, []);
  React.useEffect(function () {
    if (props.value === void 0) {
      formContext.setFormControlRef(props.name, onUpdateValue, onValidate, value);
      return;
    }
    setValue(props.value);
    formContext.setFormControlRef(props.name, onUpdateValue, onValidate, props.value);
  }, [props.value]);
  return /*#__PURE__*/jsx(FormField, {
    as: props.as,
    className: props.className,
    controlId: props.controlId,
    description: props.description,
    error: (_error$message = error === null || error === void 0 ? void 0 : error.message) !== null && _error$message !== void 0 ? _error$message : !!error,
    formId: formContext.formId,
    inline: (_formContext$inlineAl = formContext.inlineAll) !== null && _formContext$inlineAl !== void 0 ? _formContext$inlineAl : props.inline,
    label: props.label,
    labelProps: props.labelProps,
    ref: ref,
    required: props.validation && !!props.validation.required,
    children: function children(controlId) {
      return /*#__PURE__*/React.cloneElement(props.children, {
        checked: typeof value === "boolean" ? value : void 0,
        disabled: typeof formContext.disableAll === "boolean" ? formContext.disableAll : void 0,
        error: !!error,
        id: controlId,
        name: props.name,
        onBlur: onBlur,
        onChange: function onChange(event) {
          var newValue = getNewValueFromEvent(event);
          _onChange(newValue);
        },
        value: typeof value === "boolean" ? void 0 : value
      });
    }
  });
});
FormControlV2.displayName = "FormControlV2";
function getNewValueFromEvent(event) {
  if (!event || !event.target) {
    return event;
  } else if (Object.getOwnPropertyDescriptor(event.target, "checked")) {
    return event.target.checked;
  } else {
    return event.target.value;
  }
}

export { FormControlV2 };
